import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useCallback, useEffect, useState } from 'react';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from 'lexical';
import { mergeRegister } from '@lexical/utils';
import { richTextEditorStrings } from '../../../i18n/components/richtTextEditor';

export function TextFormatPlugin() {
  const [editor] = useLexicalComposerContext();
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [isStrikethrough, setIsStrikethrough] = useState(false);

  const updateTextFormat = useCallback(() => {
    const selection = $getSelection();

    if (!$isRangeSelection(selection)) {
      return;
    }

    setIsBold(selection.hasFormat('bold'));
    setIsItalic(selection.hasFormat('italic'));
    setIsUnderline(selection.hasFormat('underline'));
    setIsStrikethrough(selection.hasFormat('strikethrough'));
  }, []);

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => {
          updateTextFormat();
        });
      }),
    );
  }, [editor, updateTextFormat]);

  return (
    <span className="lexical-toolbar-group">
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold')}
        className={`lexical-toolbar-button ${isBold ? 'active' : ''}`}
        aria-label={richTextEditorStrings.textFormat.bold.label}
        title={richTextEditorStrings.textFormat.bold.title}
      >
        <strong>B</strong>
      </button>
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic')}
        className={`lexical-toolbar-button ${isItalic ? 'active' : ''}`}
        aria-label={richTextEditorStrings.textFormat.italic.label}
        title={richTextEditorStrings.textFormat.italic.title}
      >
        <em>I</em>
      </button>
      <button
        type="button"
        onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline')}
        className={`lexical-toolbar-button ${isUnderline ? 'active' : ''}`}
        aria-label={richTextEditorStrings.textFormat.underline.label}
        title={richTextEditorStrings.textFormat.underline.title}
      >
        <span style={{ textDecoration: 'underline' }}>U</span>
      </button>
      <button
        type="button"
        onClick={() =>
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'strikethrough')
        }
        className={`lexical-toolbar-button ${isStrikethrough ? 'active' : ''}`}
        aria-label={richTextEditorStrings.textFormat.strikethrough.label}
        title={richTextEditorStrings.textFormat.strikethrough.title}
      >
        <span style={{ textDecoration: 'line-through' }}>S</span>
      </button>
    </span>
  );
}
